<template>
  <div
    class="list-video"
    @click.stop
  >
    <video
      ref="player"
      v-bind="$attrs"
      :poster="posterFailed ? undefined : $attrs.poster"
      :class="{ 'list-video__waiting': showPoster }"
      playsinline
      @play="hasPlayed = true"
      @loadedmetadata="previewOpeningFrame"
      v-on="$listeners"
    ><slot /></video>
    <img
      v-if="showPoster"
      class="list-video__poster"
      :src="$attrs.poster"
      :alt="$t(&quot;Video opening frame&quot;)"
      @error="onPosterError"
    />
    <button
      v-if="showPoster"
      type="button"
      class="list-video__play"
      :aria-label="$t(&quot;Play video&quot;)"
      @click.stop="play"
    >
      <span aria-hidden="true">▶</span>
    </button>
    <p
      v-if="playError"
      class="list-video__error"
      role="status"
    >
      {{ $t("\n      This video format cannot be played in this browser.\n    ") }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'ListVideo',
  inheritAttrs: false,
  data: () => ({ hasPlayed: false, posterFailed: false, playError: false }),
  computed: {
    showPoster() { return !!this.$attrs.poster && !this.posterFailed && !this.hasPlayed },
  },
  watch: {
    '$attrs.poster': function resetPreview() {
      this.hasPlayed = false
      this.posterFailed = false
      this.playError = false
    },
  },
  methods: {
    onPosterError() {
      this.posterFailed = true
      this.$nextTick(this.previewOpeningFrame)
    },
    previewOpeningFrame() {
      const { player } = this.$refs
      if (!player || this.showPoster || this.hasPlayed || !player.paused || player.currentTime > 0.001 || player.readyState < 1) return
      if (!Number.isFinite(player.duration) || player.duration <= 0) return

      // Seek only after metadata arrives. URL time fragments prevent some older
      // imports from loading in Safari. A tenth of a second also avoids Safari's
      // blank preview when a seek lands between zero and the first video frame.
      try { player.currentTime = Math.min(0.1, player.duration / 2) } catch (_) { /* Playback remains available if seeking is not supported. */ }
    },
    async play() {
      this.playError = false
      if (this.$refs.player.error) {
        this.playError = true

        return
      }
      try { await this.$refs.player.play() } catch (_) { this.playError = true }
    },
  },
}
</script>
<style scoped lang="scss">
.list-video {
  position: relative;
  width: 100%;
  line-height: 0;
}
.list-video video {
  display: block;
  width: 100%;
  height: auto;
  min-height: 180px;
}
.list-video .list-video__waiting {
  opacity: 0;
  pointer-events: none;
}
.list-video .list-video__poster {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #16131c;
  pointer-events: none;
  transform: none !important;
  opacity: 1 !important;
}
.list-video__play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(0, 0, 0, .65);
  color: #fff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}
.list-video__play:focus-visible { outline: 2px solid #9155fd; outline-offset: 3px; }
.list-video__error {
  position: absolute;
  bottom: 0;
  margin: 0;
  padding: 8px;
  width: 100%;
  color: #fff;
  background: rgba(0, 0, 0, .8);
  font-size: 12px;
  line-height: 1.4;
}
</style>
